<template>
  <div
    class="rail-picture"
    @mouseenter="mouseEnter"
    @mouseleave="mouseLeave"
  >
  <!-- Instagram -->
    <a v-if="!isMedium" :href="link" target="_blank" :title="title">
      <div class="rail-picture__image">
        <div
          class="rail-picture__image-actual"
          :class="{ 'loaded': loaded }"
          :style="{ backgroundImage: `url(${image})` }"
        ></div>
      </div>
      <div
        class="rail-picture__content"
        data-apollo-hover data-apollo-hover-animation="scale"
      >
        <div class="rail-picture__top" v-if="isMedium">
          <div class="rail-picture__date">{{ this.date }}</div>
          <div class="rail-picture__type">News</div>
        </div>
        <div class="rail-picture__top-line" v-if="isMedium"></div>
        <div class="rail-picture__title">
          <span v-html="title"></span>
        </div>
        <div class="rail-picture__bottom" v-if="isMedium">
          <div class="rail-picture__discover">
            <span>Read more</span>
          </div>
          <div class="rail-picture__bottom-line"></div>
        </div>
      </div>
    </a>
    <!-- Blog -->
    <router-link v-else :to="link" :title="title">
      <div class="rail-picture__image">
        <div
          class="rail-picture__image-actual"
          :class="{ 'loaded': loaded }"
          :style="{ backgroundImage: `url(${image})` }"
        ></div>
      </div>
      <div
        class="rail-picture__content"
        data-apollo-hover data-apollo-hover-animation="scale"
      >
        <div class="rail-picture__top" v-if="isMedium">
          <div class="rail-picture__date">{{ this.date }}</div>
          <div class="rail-picture__type">News</div>
        </div>
        <div class="rail-picture__top-line" v-if="isMedium"></div>
        <div class="rail-picture__title">
          <span>{{ title }}</span>
        </div>
        <div class="rail-picture__bottom" v-if="isMedium">
          <div class="rail-picture__discover">
            <span>Read more</span>
          </div>
          <div class="rail-picture__bottom-line"></div>
        </div>
      </div>
    </router-link>
    <img style="display: none" :src="image" alt="Hidden">
  </div>
</template>

<script>
import engine from '@/scripts/engine';
import animations from '../../assets/animations';

export default {
  name: 'RailPicture',

  props: ['data', 'isMedium'],

  data() {
    return {
      height: 0,
      loaded: false,
      hoverTimeline: null,
      months: {
        it: [
          'Gennaio', 'Febbraio', 'Marzo',
          'Aprile', 'Maggio', 'Giugno',
          'Lugio', 'Agosto', 'Settembre',
          'Ottobre', 'Novembre', 'Dicembre',
        ],
        en: [
          'Gennaio', 'Febbraio', 'Marzo',
          'Aprile', 'Maggio', 'Giugno',
          'Lugio', 'Agosto', 'Settembre',
          'Ottobre', 'Novembre', 'Dicembre',
        ],
      },
    };
  },

  computed: {
    title() {
      let title = null;
      if (this.data.placeholder) return 'prova';
      if (this.isMedium) {
        const hero = this.data.structure.find(c => c.frontId === 'BlogHero');
        title = hero.title; // eslint-disable-line
      } else {
        title = this.data.text;
      }
      return title;
    },
    date() {
      let d = null;
      if (this.data.placeholder) return 'prova';
      if (this.isMedium) {
        const hero = this.data.structure.find(c => c.frontId === 'BlogHero');
        return hero.date;
      }
      d = new Date(this.data.taken_at_timestamp * 1000);
      return `${d.getDate()} ${this.months[this.$store.state.lang][d.getMonth()]} ${d.getFullYear()}`;
    },
    image() {
      let url = null;
      if (this.data.placeholder) return 'prova';
      if (this.isMedium) {
        const hero = this.data.structure.find(c => c.frontId === 'BlogHero');
        url = hero.poster;
      } else {
        url = this.data.image.url;
      }
      return url;
    },
    link() {
      if (this.isMedium) return `/${this.$store.state.lang}/whats-new/${this.data.key}`;
      return this.data.link;
    },
  },

  mounted() {
    engine.add(this.scroll, 'rails-image-scroll');
    this.$el.querySelector('img').addEventListener('load', () => { this.loaded = true; });
    if (this.isMedium) {
      this.hoverTimeline = animations.get('rail-picture-hover')(this.$el);
    } else {
      this.hoverTimeline = animations.get('instagram-rail-picture-hover')(this.$el);
    }
    window.addEventListener('resize', this.calcHeight);
  },

  methods: {
    scroll() {
      // const transform = 1 + (Math.max(window.innerHeight + this.$el.getBoundingClientRect().top, 0) * 0.00008);
      // this.$el.querySelector('.rail-picture__image-actual').style.transform = `scale(${transform})`;
    },
    mouseEnter() {
      this.hoverTimeline.play();
    },
    mouseLeave() {
      this.hoverTimeline.reverse();
    },
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.calcHeight);
  },
};
</script>

<style lang="scss" scoped>
.rail-picture {
  width: 100%;
  margin: calc((100vh / 18) * 2) 0;

  @at-root .is-medium & {
    margin: calc((100vh / 18) * 4) 0;

    &:first-child {
      margin-top: calc((100vh / 18) * 1);
    }

    &:last-child {
      margin-bottom: calc((100vh / 18) * 1);
    }
  }

  & a {
    display: flex;
    flex-direction: column;
    cursor: pointer;

    @at-root .rail--right & {
      flex-direction: column-reverse;
    }
  }


  &__image {
    width: 100%;
    height: calc((100vh / 18) * 8);
    overflow: hidden;
    background-color: #f5f5f5;

    @at-root .is-medium & {
      height: calc((100vh / 18) * 10);
    }

    &-actual {
      opacity: 0;
      width: 100%;
      height: 100%;
      background-position: center center;
      background-size: cover;
      transition: opacity .6s $inOutCubic;

      &.loaded {
        opacity: 1;
      }
    }
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0px;
    font-size: rem(20px);
    font-size: calc(20px * var(--rw));
  }

  &__bottom {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    padding: 20px 0px;
  }

  &__top-line,
  &__bottom-line {
    width: 100%;
    height: 2px;
    background-color: $color-primary;
  }

  &__title {
    font-size: rem(20px);
    font-size: calc(20px * var(--rw));
    padding-top: 20px;
    padding-bottom: 20px;

    & ::v-deep .hashtags {
      opacity: 0.6;
      font-size: rem(16px);
      font-size: calc(16px * var(--rw));
      line-height: rem(16px);
      line-height: calc(16px * var(--rw));
    }

    @at-root .is-medium & {
      font-size: rem(50px);
      font-size: calc(50px * var(--rw));
      text-transform: uppercase;
      padding-top: 20px;
      padding-bottom: 50px;
    }
  }

  &__discover {
    width: 180px;
    font-family: 'IGT Frankling Gothic';
    font-size: rem(20px);
    font-size: calc(20px * var(--rw));
    text-transform: uppercase;
    font-weight: bold;
  }
}
</style>
